module.exports = __webpack_public_path__ + "media/more_review_app/assets/images/close_icon-66a448bec9bc7689baf32472cb89b945.png";